import { createElement } from 'react';
import { Modal as OriginalModal, ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import enUS from 'antd/es/locale/en_US';
import 'antd/dist/antd.variable.min.css';
import '../../variables.scss';
const Modal = (props) => {
    ConfigProvider.config({
        theme: {
            primaryColor: '#f16622',
        },
    });
    const innerProps = {};
    if (props.__designmode === 'design') {
        // 低代码编辑态中强制显示，将控制权交给引擎侧
        innerProps.open = true;
    }
    return (createElement(ConfigProvider, { locale: localStorage.getItem('umi_locale') !== 'en-US' ? zhCN : enUS },
        createElement(OriginalModal, { ...props, ...innerProps })));
};
Modal.info = OriginalModal.info;
Modal.success = OriginalModal.success;
Modal.error = OriginalModal.error;
Modal.warning = OriginalModal.warning;
Modal.warn = OriginalModal.warn;
Modal.confirm = OriginalModal.confirm;
export default Modal;
